module.exports = __webpack_public_path__ + "static/media/r2gsmall.4af3ab4e.webp";